// services/notificationService.js

import emitter from "../Utils/eventEmitter";

export const triggerSnackbar = (message, severity = 'info') => {
  emitter.emit('show-snackbar', message, severity);
};
